export enum DefaultTypeIdentifiersCodeList {
  COUNTRY_SUB_DIVISION_STATE = "STATE",
  EDUCATION_DEGREE_TYPE_SPECIALIZATIONS_FIELD_OF_STUDY = "FIELD_OF_STUDY",
  CANDIDATE_PROFILE_TYPE_DEFAULT = "Default",
  CERTIFICATION_TYPE_IDENTIFIER_SCHEME = "Number"
};